import { Pipe, PipeTransform } from '@angular/core';
import { isNil, startCase } from 'lodash-es';

/*
 * Capitalizes the first letter of a string.
*/
@Pipe({ name: 'propercase' })
export class PropercasePipe implements PipeTransform {
  transform(value: any): string {
    if (isNil(value)) {
      return '';
    }
    value = value as string;

    return startCase(value);
  }
}
